<script setup>
  import {onUnmounted} from "vue";
  onUnmounted(()=>{
    document.getElementById('chatbase-bubble-button').remove()
    document.getElementById('chatbase-message-bubbles').remove()
    document.getElementById('chatbase-bubble-window').remove()
  })
</script>

<template>
  <component is="script" src="https://www.chatbase.co/embed.min.js" id="LQoZKsUtIInvRprcrkjpN" domain="www.chatbase.co" async></component>
</template>
